getExperiment = require 'lib/experiments/simple-test'

# superHomeTeamCards is dependent on superHomeTeamBoards,
# so only show team cards if both are enabled.
module.exports = ->
  getExperiment('superHomeTeamBoards').get('enabled') &&
  getExperiment('superHomeTeamCards').get('enabled')


// WEBPACK FOOTER //
// ./app/scripts/lib/home/is-home-team-cards-enabled.coffee